var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCentivoLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Centivo_logo",
    d: "M810.237,2223.72v2.544a9.593,9.593,0,0,1,5.952,4.6l-4.3,2.037a4.867,4.867,0,1,0-.023,5.439l4.317,2.006a9.593,9.593,0,0,1-5.944,4.595,9.48,9.48,0,0,1-4.7,0,9.66,9.66,0,0,1-.006-18.679v-2.544a12,12,0,1,0,4.705,0Zm-2.353,14.267a2.384,2.384,0,1,1,2.361-2.384A2.375,2.375,0,0,1,807.885,2237.988Z",
    transform: "translate(-795.885 -2223.721)",
    fill: "#00aabe"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCentivoLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_centivo_logo.f1ff41c26de20fe60f5888fd46d7a4c9.svg";